export const GET_PROFILE_LOADING = "get/profile/loading" 
export const GET_PROFILE_SUCCESS = "get/profile/success" 
export const GET_PROFILE_ERROR = "get/profile/error" 